import axios from "axios";

class CoinsService {
    getCoinsList() {
        return axios.get('/api/Home/v1/coins');
    }
}

export default new CoinsService();
